/**
 * GeChiUI dependencies
 */
import { Path, SVG } from '@gechiui/components';

export default (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm-2 14.5v-9l6 4.5z"
			fill="white"
		/>
	</SVG>
);
